export default "__VITE_ASSET__BoJg6iuM__"